// extracted by mini-css-extract-plugin
export default {"modalOverlay":"zB-z","modalContent":"AB-z","header":"BB-z","close":"CB-z"};